import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SearchOutlined } from '@ant-design/icons';
import AutocompleteInput from '~components/search-input/autocomplete-input';

export default class SearchInput extends React.Component {
  handleInputChange = value => {
    this.setState({
      inputValue: value,
    });
  };

  handleSelect = e => {
    this.props.onChange(e);
  };

  render() {
    const { t } = this.props;
    return (
      <div
        className={classNames('search-input', 'search-input--expand')}
        onClick={this.handleSearchExpand}
        role="presentation"
        ref={node => {
          this.searchContainer = node;
        }}
      >
        <div
          className={classNames(
            'search-input__icon-container',
            'search-input__icon-container--expand',
          )}
        >
          <SearchOutlined
            className={classNames('search-input__icon', 'search-input__icon--expand')}
            style={{ fontSize: '16px' }}
          />
          <AutocompleteInput
            onSelect={this.handleSelect}
            onChange={this.handleInputChange}
            t={t}
            type="address"
            inputProps={{
              autoFocus: true,
              placeholder: t('cms:cms.properties.create.property_address.search_address'),
            }}
          />
        </div>
        <span className="search-input__icon-text">
          {t('cms:cms.properties.create.property_address.search_address')}
        </span>
      </div>
    );
  }
}

SearchInput.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

SearchInput.defaultProps = {
  t: () => {},
  onChange: () => {},
};
